// import React, { useState, useEffect } from 'react'
// import { useForm } from 'react-hook-form';
// import { useNavigate, Link } from "react-router-dom";
// import { loadStripe } from '@stripe/stripe-js';
// import { postApi } from '../services/helpers/apiCall';
// import { validateEmail, validateName } from '../services/helpers';
// import InputOTP from '@onefifteen-z/react-input-otp';
// import './otp-styles.css'
// import { BsCheckCircleFill } from "react-icons/bs"
// import countriesList from '../services/countries';
// import axios from 'axios';
// import { toAbsoluteUrl } from '../services';
// // import { signupPageAssets } from '../assets/media';
// // const { eugdprLight, iso } = footerAssets
// // const { logoYellow } = generalAssets.brandLogo
// // const { otpMobile, optsvg } = signupPageAssets





// const Signup = (props) => {

//   let { tier,
//     setIsOtp,
//     isOtpSend,
//     setIsOtpSend } = props


//   const [hide, setHide] = useState(true);

//   var navigate = useNavigate()

//   const planComesWith = {
//     "free": [
//       "25 Internal Candidate Assessments",
//       "1 Assessment Game",
//       "Access To Test Library",
//       "Pre-selected Fields for Data Collection",

//     ],
//     "standard": [
//       "300 Candidate Assessments",
//       "1 Assessment Game",
//       "Access to Test library",
//       "Pre-selected Fields for Data Collection",
//       "Customizable Data Fields (limited)",
//       "Candidate Feedback Survey"

//     ],
//     "premium": [
//       "1200 Candidate Assessments",
//       "2 Assessment Games",
//       "Access to Test library",
//       "Pre-selected Fields for Data Collection",
//       "Customizable Data Fields",
//       "Candidate Feedback Survey"
//     ],
//   }

//   const { register, getValues, handleSubmit, formState: { errors } } = useForm()

//   const [isSubmitted, setisSubmitted] = useState(false)
//   const [isOTPTriggered, setisOTPTriggered] = useState(false)
//   const [sid, setsid] = useState()



//   const handleFormSubmit = async () => {
//     console.log(getValues('country').toLowerCase())
//     if (!sid) {

//       setisOTPTriggered(true)

//       // API OBJECT
//       let otpSendRequestObj = {
//         data: {
//           email: getValues('workEmail').toLowerCase()
//         },
//         config: {}
//       }



//       // API CALL
//       await axios.post('https://backendpaygo.thetalent.games/auth/email/send-otp', {
//         email: getValues('workEmail').toLowerCase()
//       })
//         .then(response => {
//           const data = response.data;
//           const ressid = data.verification.sid;
//           console.log("sid", ressid);
//           setisSubmitted(true);

//           setIsOtp(true)
//           setHide(false)


//           setisOTPTriggered(false);
//           const candidateEmail = getValues('workEmail');
//           localStorage.setItem('candidateEmail', candidateEmail);
//           setsid(ressid);
//         })
//         .catch(error => {
//           console.log(error);
//         });

//     }

//   }

//   const [otpError, setotpError] = useState({ error: false, errorMessage: "" })
//   const [otpValue, setotpValue] = useState('')
//   const [disabledOTPInput, setdisabledOTPInput] = useState(false)
//   const [isEmailExists, setisEmailExists] = useState({ isExists: true, msg: '' })


//   // const handleOTPChange = async (otp) => {

//   //   // setdisabledOTPInput(true)
//   //   if (otp.length === 6) {

//   //     // const stripe = await loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)
//   //   }
//   // }

//   const handleOTPChange = async (otp) => {
//     // setdisabledOTPInput(true)
//     setotpValue(otp)
//   }

//   const handleOtpSubmit = () => {
//     const otpVerificationRequestObj = {
//       url: "https://backendpaygo.thetalent.games/auth/email/verify-otp",
//       data: {
//         otp: otpValue,
//         token: sid
//       },
//       config: {
//       }
//     }

//     const postApi3 = async (apiCallRequest) => {
//       let { url, data, config } = apiCallRequest
//       return await axios.post(url, data, config)

//     }

//     postApi3(otpVerificationRequestObj)
//       .then(response => {
//         console.log('token', sid)

//         const token = sessionStorage.setItem('token', sid)


//         const data = response.data;
//         if (data.isVerified === false) {
//           setotpError({ error: true, errorMessage: "WRONG OTP ENTERED" });
//           setdisabledOTPInput(false);
//           setotpValue('');
//         } else {
//           setotpError({ error: false, errorMessage: " " });
//           setdisabledOTPInput(true);

//           // API Call for Checkout Session
//           const apiCallRequest = {
//             url: "https://backendpaygo.thetalent.games/auth/pay/create-checkout-session",
//             data: {
//               name: getValues('fullName'),
//               phone: "",
//               type: tier,
//               email: getValues('workEmail').toLowerCase(),
//               jobtitle: getValues('jobTitle'),
//               company: getValues('companyName'),
//               country: getValues('country').toLowerCase()
//             },
//             config: {}
//           };



//           axios.post(apiCallRequest.url, apiCallRequest.data, apiCallRequest.config)
//           console.log(apiCallRequest.data)
//             .then(apiResponse => {
//               const responseData = apiResponse.data;
//               const sessionId = responseData?.session?.id;
//               localStorage.setItem('sessionId', JSON.stringify(sessionId));
//               setIsOtp(false)
//               setIsOtpSend(true)
//             })
//             .catch(apiError => {
//               console.log(apiError);
//             });
//         }
//       })
//       .catch(error => {
//         console.log('eeee', error.message);
//       });
//   }

//   const handleSucceed = () => {
//     setIsOtpSend(false)
//     navigate('/')
//   }


//   useEffect(() => {

//     // console.log(otpValue)

//   }, [otpValue])

//   const email = localStorage.getItem('candidateEmail')


//   return (
//     <div className="signupPage mt-8 z-10 ">

//       {
//         hide ?
//           <>
//             <div className='z-10 bg-white drop-shadow-md rounded-lg pt-8  2xl:px-10 xl:px-10 lg:px-8 md:px-8 px-6 mb-11'>
//               <h2 className='text-[40px] text-center font-medium mt-3 2xl:text-[40px] lg:mt-0 xl:text-[40px] font--monstserrat'>
//                 Start Your <span className='text-[#007e8c] font-bold font--monstserrats'> Free Trial</span>
//               </h2>
//               <p className=' text-center text-[15px] mt-1 mb-3 tracking-wider font-semibold font--monstserrat'>(No Credit Card Required)</p>

//               <div className="signupPageWrapper pb-[130px] relative flex">

//                 {/* left side Signup Form */}
//                 <div className="right-form  lg:w-[50%] ">
//                   <div className="form lg:w-[100%] 2xl:w-[100%] sm:w-[100%] mx-auto px-[2rem] md:px-8 lg:mt-1 ">
//                     <div className="logo flex justify-center mb-10 xl:mb-3 lg:mb-5">
//                       <Link to={'/'}>
//                         {/* <img src={logoYellow} alt="logo" className='h-[4rem] object-contain xl:h-[5rem] 2xl:h-[6rem]' /> */}
//                       </Link>
//                     </div>

//                     <form onSubmit={handleSubmit(handleFormSubmit)} className=' mt-10 lg:mt-5 xl:mt-3 2xl:mt-4 text-[#7E7E7E] pb-5'>
//                       {/* Email */}
//                       <div className="field w-full">
//                         <div className="label">
//                           <label htmlFor="workEmail" className='text-black md:font-normal font--monstserrat font-medium md:text-[#5A5A5A] 2xl:text-[14px] 2xl:font-[600] 2xl:leading-[24px] lg:text-[14px]'>Work Email *</label>
//                         </div>
//                         <div className="input mt-2 lg:mt-1 xl:mt-0">
//                           <input
//                             {...register("workEmail", {
//                               required: {
//                                 value: true, message: "Field cannot be empty"
//                               },
//                               pattern: {
//                                 value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
//                                 message: 'Please enter a valid email',
//                               },
//                               validate: { validateEmail }
//                             })}
//                             className={`${errors.workEmail && 'border border-red-500  outline-none 2xl:h-[50px]'} w-[100%] 2xl:py-[11px] 2xl:text-[14px] 2xl:leading-[28px] border border-gray-200 bg-[#F9F9F9] rounded h-[2.2rem] px-5 py-6 md:p-2 outline-none lg:text-[14px] xl:text-[13px] xl:h-[35px] '`}
//                             type="email"
//                             name="workEmail"
//                             id="workEmail"
//                             placeholder='Eg: example@xyzconsultants.com'
//                           />
//                           <p className='text-red-500 text-xs mt-1'>{errors.workEmail && errors.workEmail.message}</p>
//                           {/* <p className='text-red-500'>{validateEmail(getValues('workEmail')) && "try with work email"}</p> */}

//                         </div>
//                       </div>
//                       {/* Name */}
//                       <div className="field w-full mt-5 lg:mt-2 xl:mt-3 2xl:mt-4">
//                         <div className="label">
//                           <label htmlFor="fullName" className='text-black md:font-normal font--monstserrat font-medium md:text-[#5A5A5A] 2xl:text-[14px] 2xl:font-[600] 2xl:leading-[24px] lg:text-[14px]'>Full Name *</label>
//                         </div>
//                         <div className="input mt-2 xl:mt-0">
//                           <input
//                             {...register("fullName", {
//                               required: {
//                                 value: true, message: "Field cannot be empty"
//                               },
//                               validate: { validateName }
//                             })}
//                             className={`${errors.fullName && 'border border-red-500'} 2xl:h-[50px]'} w-[100%] 2xl:py-[11px] 2xl:text-[14px] 2xl:leading-[28px] rounded h-[2.2rem] px-5 py-6 md:p-2 outline-none lg:text-[14px] xl:text-[13px] xl:h-[35px] bg-[#F9F9F9] border border-gray-200 `}
//                             type="text"
//                             name="fullName"
//                             id="fullName"
//                             placeholder='Eg: John Doe' />
//                           <p className='text-red-500 text-xs mt-1'>{errors.fullName && errors.fullName.message}</p>

//                         </div>
//                       </div>
//                       {/* Company Name */}
//                       <div className="field w-full mt-5 lg:mt-2 xl:mt-3 2xl:mt-4">
//                         <div className="label">
//                           <label htmlFor="companyName"
//                             className='text-black font--monstserrat font-medium md:font-normal md:text-[#5A5A5A] 2xl:text-[14px] 2xl:font-[600] 2xl:leading-[24px] lg:text-[14px]'>Company Name *</label>
//                         </div>
//                         <div className="input mt-2 xl:mt-0">
//                           <input
//                             {...register("companyName", {
//                               required: {
//                                 value: true, message: "Field cannot be empty"
//                               },
//                               validate: { validateName }
//                             })}
//                             className={` ${errors.companyName && 'border border-red-500'} 2xl:h-[50px]'} w-[100%] 2xl:py-[11px] 2xl:text-[14px] 2xl:leading-[28px] rounded h-[2.2rem] px-5 py-6 md:p-2 w-full outline-none lg:text-[14px] xl:text-[13px] xl:h-[35px] bg-[#F9F9F9] border border-gray-200 `} type="text" name="companyName" id="companyName" placeholder='Eg: XYZ Consultants' />
//                           <p className='text-red-500 text-xs mt-1'>{errors.companyName && errors.companyName.message}</p>

//                         </div>
//                       </div>

//                       {/* Job Title */}
//                       <div className="field w-full mt-5 lg:mt-2 xl:mt-3 2xl:mt-4">
//                         <div className="label">
//                           <label htmlFor="companyName" className='text-black font--monstserrat font-medium md:font-normal md:text-[#5A5A5A] 2xl:text-[14px] 2xl:font-[600] 2xl:leading-[24px] lg:text-[14px]'>Job Title *</label>
//                         </div>
//                         <div className="input mt-2 xl:mt-0">
//                           <input
//                             {...register("jobTitle", {
//                               required: {
//                                 value: true, message: "Field cannot be empty"
//                               },
//                               validate: { validateName }
//                             })}
//                             className={` ${errors.jobTitle && 'border border-red-500'} 2xl:h-[50px]'} w-[100%] 2xl:py-[11px] 2xl:text-[14px] 2xl:leading-[28px] rounded h-[2.2rem] px-5 py-6 md:p-2 outline-none lg:text-[14px] xl:text-[13px] xl:h-[35px] bg-[#F9F9F9] border border-gray-200 `} type="text" name="jobTitle" id="jobTitle" placeholder='Eg: HR Manager' />
//                           <p className='text-red-500 text-xs mt-1'>{errors.jobTitle &&  errors.jobTitle.message}</p>

//                         </div>
//                       </div>

//                       {/* Country */}
//                       <div className="field w-full mt-5 lg:mt-2 xl:mt-3 2xl:mt-4">
//                         <div className="label">
//                           <label htmlFor="country" className='text-black font--monstserrat font-medium md:font-normal md:text-[#5A5A5A] 2xl:text-[14px] 2xl:font-[600] 2xl:leading-[24px] lg:text-[14px]'>Country *</label>
//                         </div>
//                         <div className="input mt-2 xl:mt-0">
//                           <select  {...register("country", { required: true })} className={` ${errors.country && 'border border-red-500'} 2xl:h-[50px]'} w-[100%]  2xl:text-[14px] 2xl:leading-[28px] rounded h-[3.2rem] px-5 lg:py-2 md:p-2 outline-none lg:text-[14px] xl:text-[13px] 2xl:py-2 xl:h-[35px] bg-[#F9F9F9] border border-gray-200 `} type="text" name="country" id="country">
//                             <option value="">Select Country</option>
//                             {
//                               countriesList.map((country, index) =>
//                                 <option value={country.label}>{country.label}</option>
//                               )
//                             }

//                           </select>

//                           <p className='text-red-500 text-xs mt-1'>{errors.country && 'Field cannot be empty'}</p>

//                         </div>
//                       </div>


//                       <div className="field w-full mt-5 lg:mt-3">


//                         <div className="checkBox flex items-center mt-5 lg:mt-2 text-[#ffd700]">
//                           <input value="yes" {...register("isAgree", { required: true })} className='h-4 w-4 mr-2 flex-shrink-0' type="checkbox" />
//                           <p className='xl:text-[13px] font--monstserrat 2xl:text-[12px] text-[#5A5A5A]'>I agree to the <span className='font-semibold underline'>
//                             <a className='text-[#007E8C] font--monstserrat' href="https://thetalentgames.com/terms-of-use/">Terms of use</a></span> & <span className='font-semibold underline'>
//                               <a className='text-[#007E8C] font--monstserrat' href="https://thetalentgames.com/privacy-policy/">Privacy Policy</a></span></p>
//                         </div>
//                         <p className='text-red-500 text-xs mt-1'>{errors.isAgree && 'To proceed, you must click the agreement check box above'}</p>

//                         <div style={{
//                           position: 'absolute',
//                           bottom: '40px',
//                           width: '340px',
//                           margin: '0 auto',
//                           lineHeight: 0,
//                           left: 0,
//                           right: 0
//                         }}
//                           className="proceed mt-5">
//                           <button disabled={isSubmitted} type='submit' className='bg-[#007E8C] font--monstserrat h-[2.8rem] p-3 md:h-[2.5rem] md:p-2 w-full mt-5 rounded text-md text-[#ffffff]  xl:text-sm xl:mt-2 2xl:h-[2.5rem]'

//                           >
//                             <div className="  flex items-center justify-center">
//                               {

//                                 isOTPTriggered &&
//                                 <div className="icon"> <i className="fa fa-circle-o-notch fa-spin mr-2 font--monstserrat" style={{ fontSize: "16px" }}></i></div>
//                               }
//                               <div className="text font-bold md:font-semibold">
//                                 {
//                                   isSubmitted ? 'PLEASE WAIT' : 'Send One-Time-Password'
//                                 }
//                               </div>
//                             </div>

//                           </button>

//                           <button onClick={() => navigate('/')} className='bg-[#ffd700] font--monstserrat font-semibold h-[2.8rem] p-3 md:h-[2.5rem] md:p-2 w-full mt-5 rounded text-md text-[#4F4F4F]  xl:text-sm xl:mt-2 2xl:h-[2.5rem]' >
//                             Cancel
//                           </button>
//                         </div>

//                         <div>
//                         </div>
//                       </div>
//                     </form>
//                   </div>
//                 </div>

//                 {/* right side */}
//                 <div className="left lg:w-[50%] lg:flex lg:justify-between lg:items-start p-10 lg:p-0">

//                   <div className="leftMainContent mx-auto mt-[1rem] flex flex-col items-center lg:items-start 2xl:items-start">
//                     <h4 className='font--monstserrat text-[32px] text-[#007e8c] font-[800] 2xl:text-[28px]'>Your Plan Comes With</h4>
//                     <div className="bulleticks mt-5 text-md">
//                       {
//                         planComesWith[tier].map((desc, index) =>
//                           <div key={desc + index} className="bulletTick flex items-center mt-2">
//                             <BsCheckCircleFill className='text-[#ffd700] bg-[#007e8c]  border-[#ffd700]  rounded-full 2xl:text-[26px] 2xl:mr-2' />
//                             <p className='ml-2 font--monstserrat 2xl:text-[16px]'>{desc}</p>
//                           </div>
//                         )
//                       }
//                     </div>
//                   </div>
//                 </div>



//               </div>
//             </div>
//           </>
//           :
//           <div className="right-otp  lg:w-[100%]   bg-[white] my-2 mx-6">
//             {isOtpSend ?
//               <>
//                 <div className='heading relative'>
//                   <h2 className='text-[1.5rem] font--monstserrat md:text-[1.8rem] pt-[40px] text-center font-bold  mt-2 text-[#007e8c] lg:text-[24px] 2xl:text-[32px] lg:mt-0 xl:text-[18px]'>
//                     CONGRATULATIONS
//                   </h2>
//                   <div className='celebration-img absolute top-[16px] w-[82%] left-[59px] '>
//                     <img src={toAbsoluteUrl('/media/signup/calebration-img.png')} />
//                   </div>
//                 </div>

//                 <div className="form lg:w-[90%] max-w-[36rem] sm:w-[40rem] mx-auto lg:flex lg:flex-col lg:items-center lg:justify-center  lg:py-1 lg:mt-2 ">
//                   <p className='text-[#434141] font--monstserrat text-center mt-[18px] mb-[16px] md:text-[16px] md:leading-[28px] lg:text-[16px] lg:leading-[28px] xl:text-[16px] xl:leading-[30px] 2xl:text-[18px] 2xl:leading-[32px] font-[500]'>
//                     Your <b>FREE TRIAL</b> is ready! We have sent you an email with your log in details at <b>{email}</b>
//                   </p>
//                 </div>

//                 <div className='btn-proceed text-center'>
//                   <button onClick={handleSucceed} className='px-6 font--monstserrat mb-6 py-2 bg-[#007E8C] w-[250px] rounded leading-normal text-center'>
//                     <span className="w-100 no-underline	 d-block text-white font--monstserrat text-lg capitalize ">click here to login</span>
//                   </button>
//                 </div>

//               </>
//               :
//               <div className="rightMainContent rounded-lg  w-[100%]">
//                 <div className="form lg:w-[100%] 2xl:w-[36rem] sm:w-[40rem] mx-auto lg:flex lg:flex-col lg:items-center lg:justify-center p-5 lg:py-1 px-8 lg:mt-2 ">
//                   <div className="logo flex justify-center mb-10 xl:mb-3 lg:mb-5">
//                     {/* ttg logo */}
//                     {/* <img src={logoYellow} alt="logo" className='h-[3.5rem] object-contain md:h-[6rem] lg:h-[6rem] xl:h-[4rem] 2xl:h-[10rem]' /> */}
//                   </div>

//                   <h2 className='text-[1.5rem] md:text-[1.8rem] text-center font-semibold  uppercase   lg:text-[24px] 2xl:text-[32px] font--monstserrat lg:mt-3 xl:text-[18px]'>Please Enter The <span className='text-[#007e8c] font-bold'>OTP</span></h2>

//                   {/* otp box */}
//                   <div className="otpBox mt-[2rem] md:mt-[25px] flex flex-col justify-center items-center">
//                     {/* otp avatar */}
//                     <img src={toAbsoluteUrl('/media/signup/otpImage.png')} alt="otp avatar" className='block object-contain w-[40%] md:w-[50%]' />

//                     <p className='text-[#434141] text-center mt-[22px] mb-[22px] md:text-[16px] md:leading-[28px] lg:text-[16px] lg:leading-[28px] xl:text-[16px] xl:leading-[30px] font--monstserrat 2xl:text-[20px] 2xl:leading-[24px] font-[500]'>Your OTP (one-time-password) has been generated and sent to your email address.</p>

//                     <InputOTP value={otpValue} onChange={handleOTPChange} disabled={disabledOTPInput} numberOnly={true} error={otpError.error} errorMessage={otpError.errorMessage} autoFocus={true} />


//                     {/* loader */}
//                     {
//                       <button onClick={handleOtpSubmit} className='px-6 mt-7 mb-8 py-3 bg-[#007E8C] w-[250px] rounded leading-normal text-center'>
//                         <span className="w-100 no-underline	font--monstserrat d-block text-white font-medium text-lg capitalize ">Submit OTP</span>

//                       </button>
//                     }

//                     {
//                       disabledOTPInput && isEmailExists.isExists === true &&
//                       <div className="loader">
//                         <p>Please wait ..</p>
//                       </div>
//                     }
//                     {
//                       isEmailExists.isExists == false &&
//                       <div className="loader">
//                         <p>{isEmailExists.msg}</p>
//                       </div>
//                     }

//                   </div>
//                 </div>
//               </div>
//             }


//           </div>

//       }
//     </div>

//   )
// }

// export default Signup

import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form';
import { useNavigate, Link } from "react-router-dom";
import { loadStripe } from '@stripe/stripe-js';
import { postApi } from '../services/helpers/apiCall';
import { validateEmail, validateName } from '../services/helpers';
import InputOTP from '@onefifteen-z/react-input-otp';
import './otp-styles.css'
import { BsCheckCircleFill } from "react-icons/bs"
import countriesList from '../services/countries';
import axios from 'axios';
import { toAbsoluteUrl } from '../services';
// import { signupPageAssets } from '../assets/media';
// const { eugdprLight, iso } = footerAssets
// const { logoYellow } = generalAssets.brandLogo
// const { otpMobile, optsvg } = signupPageAssets





const Signup = (props) => {

  let { tier,
    setIsOtp,
    isOtpSend,
    setIsOtpSend } = props


  const [hide, setHide] = useState(true);

  var navigate = useNavigate()

  const planComesWith = {
    "free": [
      "25 Internal Candidate Assessments",
      "1 Assessment Game",
      "Access To Test Library",
      "Pre-selected Fields for Data Collection",

    ],
    "standard": [
      "300 Candidate Assessments",
      "1 Assessment Game",
      "Access to Test library",
      "Pre-selected Fields for Data Collection",
      "Customizable Data Fields (limited)",
      "Candidate Feedback Survey"

    ],
    "premium": [
      "1200 Candidate Assessments",
      "2 Assessment Games",
      "Access to Test library",
      "Pre-selected Fields for Data Collection",
      "Customizable Data Fields",
      "Candidate Feedback Survey"
    ],
  }

  const { register, getValues, handleSubmit, formState: { errors } } = useForm()

  const [isSubmitted, setisSubmitted] = useState(false)
  const [isOTPTriggered, setisOTPTriggered] = useState(false)
  const [sid, setsid] = useState()



  const handleFormSubmit = async () => {
    console.log(getValues('country').toLowerCase())
    if (!sid) {

      setisOTPTriggered(true)

      // API OBJECT
      let otpSendRequestObj = {
        data: {
          email: getValues('workEmail').toLowerCase()
        },
        config: {}
      }



      // API CALL
      await axios.post('https://backendpaygo.thetalent.games/auth/email/send-otp', {
        email: getValues('workEmail').toLowerCase()
      })
        .then(response => {
          const data = response.data;
          const ressid = data.verification.sid;
          console.log("sid", ressid);
          setisSubmitted(true);

          setIsOtp(true)
          setHide(false)


          setisOTPTriggered(false);
          const candidateEmail = getValues('workEmail');
          localStorage.setItem('candidateEmail', candidateEmail);
          setsid(ressid);
        })
        .catch(error => {
          console.log(error);
        });

    }

  }

  const [otpError, setotpError] = useState({ error: false, errorMessage: "" })
  const [otpValue, setotpValue] = useState('')
  const [disabledOTPInput, setdisabledOTPInput] = useState(false)
  const [isEmailExists, setisEmailExists] = useState({ isExists: true, msg: '' })


  // const handleOTPChange = async (otp) => {

  //   // setdisabledOTPInput(true)
  //   if (otp.length === 6) {

  //     // const stripe = await loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)
  //   }
  // }

  const handleOTPChange = async (otp) => {
    // setdisabledOTPInput(true)
    setotpValue(otp)
  }

  const handleOtpSubmit = () => {
    const otpVerificationRequestObj = {
      url: "https://backendpaygo.thetalent.games/auth/email/verify-otp",
      data: {
        otp: otpValue,
        token: sid
      },
      config: {
      }
    }

    const postApi3 = async (apiCallRequest) => {
      let { url, data, config } = apiCallRequest
      return await axios.post(url, data, config)

    }

    postApi3(otpVerificationRequestObj)
      .then(response => {
        console.log('token', sid)

        const token = sessionStorage.setItem('token', sid)


        const data = response.data;
        if (data.isVerified === false) {
          setotpError({ error: true, errorMessage: "WRONG OTP ENTERED" });
          setdisabledOTPInput(false);
          setotpValue('');
        } else {
          setotpError({ error: false, errorMessage: " " });
          setdisabledOTPInput(true);

          // API Call for Checkout Session
          const apiCallRequest = {
            url: "https://backendpaygo.thetalent.games/auth/pay/create-checkout-session",
            data: {
              name: getValues('fullName'),
              phone: "",
              type: tier,
              email: getValues('workEmail').toLowerCase(),
              jobtitle: getValues('jobTitle'),
              company: getValues('companyName'),
              country: getValues('country').toLowerCase()
            },
            config: {}
          };



          axios.post(apiCallRequest.url, apiCallRequest.data, apiCallRequest.config)
          
            .then(apiResponse => {
              const responseData = apiResponse.data;
              console.log(responseData)
              // const sessionId = responseData?.session?.id;
              // localStorage.setItem('sessionId', JSON.stringify(sessionId));
              setIsOtp(false)
              setIsOtpSend(true)
            })
            .catch(apiError => {
              console.log(apiError);
            });
        }
      })
      .catch(error => {
        console.log('eeee', error);
      });
  }

  const handleSucceed = () => {
    setIsOtpSend(false)
    navigate('/')
  }


  useEffect(() => {

    // console.log(otpValue)

  }, [otpValue])

  const email = localStorage.getItem('candidateEmail')


  return (
    <div className="signupPage mt-8 z-10 ">

      {
        hide ?
          <>
            <div className='z-10 bg-white drop-shadow-md rounded-lg pt-8  2xl:px-10 xl:px-10 lg:px-8 md:px-8 px-6 mb-11'>
              <h2 className='text-[40px] text-center font-medium mt-3 2xl:text-[40px] lg:mt-0 xl:text-[40px] font--monstserrat'>
                Start Your <span className='text-[#007e8c] font-bold font--monstserrats'> Free Trial</span>
              </h2>
              <p className=' text-center text-[15px] mt-1 mb-3 tracking-wider font-semibold font--monstserrat'>(No Credit Card Required)</p>

              <div className="signupPageWrapper pb-[130px] relative flex">

                {/* left side Signup Form */}
                <div className="right-form  lg:w-[50%] ">
                  <div className="form lg:w-[100%] 2xl:w-[100%] sm:w-[100%] mx-auto px-[2rem] md:px-8 lg:mt-1 ">
                    <div className="logo flex justify-center mb-10 xl:mb-3 lg:mb-5">
                      <Link to={'/'}>
                        {/* <img src={logoYellow} alt="logo" className='h-[4rem] object-contain xl:h-[5rem] 2xl:h-[6rem]' /> */}
                      </Link>
                    </div>

                    <form onSubmit={handleSubmit(handleFormSubmit)} className=' mt-10 lg:mt-5 xl:mt-3 2xl:mt-4 text-[#7E7E7E] pb-5'>
                      {/* Email */}
                      <div className="field w-full">
                        <div className="label">
                          <label htmlFor="workEmail" className='text-black md:font-normal font--monstserrat font-medium md:text-[#5A5A5A] 2xl:text-[14px] 2xl:font-[600] 2xl:leading-[24px] lg:text-[14px]'>Work Email *</label>
                        </div>
                        <div className="input mt-2 lg:mt-1 xl:mt-0">
                          <input
                            {...register("workEmail", {
                              required: {
                                value: true, message: "Field cannot be empty"
                              },
                              pattern: {
                                value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                message: 'Please enter a valid email',
                              },
                              validate: { validateEmail }
                            })}
                            className={`${errors.workEmail && 'border border-red-500  outline-none 2xl:h-[50px]'} w-[100%] 2xl:py-[11px] 2xl:text-[14px] 2xl:leading-[28px] border border-gray-200 bg-[#F9F9F9] rounded h-[2.2rem] px-5 py-6 md:p-2 outline-none lg:text-[14px] xl:text-[13px] xl:h-[35px] '`}
                            type="email"
                            name="workEmail"
                            id="workEmail"
                            placeholder='Eg: example@xyzconsultants.com'
                          />
                          <p className='text-red-500 text-xs mt-1'>{errors.workEmail && errors.workEmail.message}</p>
                          {/* <p className='text-red-500'>{validateEmail(getValues('workEmail')) && "try with work email"}</p> */}

                        </div>
                      </div>
                      {/* Name */}
                      <div className="field w-full mt-5 lg:mt-2 xl:mt-3 2xl:mt-4">
                        <div className="label">
                          <label htmlFor="fullName" className='text-black md:font-normal font--monstserrat font-medium md:text-[#5A5A5A] 2xl:text-[14px] 2xl:font-[600] 2xl:leading-[24px] lg:text-[14px]'>Full Name *</label>
                        </div>
                        <div className="input mt-2 xl:mt-0">
                          <input
                            {...register("fullName", {
                              required: {
                                value: true, message: "Field cannot be empty"
                              },
                              validate: { validateName }
                            })}
                            className={`${errors.fullName && 'border border-red-500'} 2xl:h-[50px]'} w-[100%] 2xl:py-[11px] 2xl:text-[14px] 2xl:leading-[28px] rounded h-[2.2rem] px-5 py-6 md:p-2 outline-none lg:text-[14px] xl:text-[13px] xl:h-[35px] bg-[#F9F9F9] border border-gray-200 `}
                            type="text"
                            name="fullName"
                            id="fullName"
                            placeholder='Eg: John Doe' />
                          <p className='text-red-500 text-xs mt-1'>{errors.fullName && errors.fullName.message}</p>

                        </div>
                      </div>
                      {/* Company Name */}
                      <div className="field w-full mt-5 lg:mt-2 xl:mt-3 2xl:mt-4">
                        <div className="label">
                          <label htmlFor="companyName"
                            className='text-black font--monstserrat font-medium md:font-normal md:text-[#5A5A5A] 2xl:text-[14px] 2xl:font-[600] 2xl:leading-[24px] lg:text-[14px]'>Company Name *</label>
                        </div>
                        <div className="input mt-2 xl:mt-0">
                          <input
                            {...register("companyName", {
                              required: {
                                value: true, message: "Field cannot be empty"
                              },
                              validate: { validateName }
                            })}
                            className={` ${errors.companyName && 'border border-red-500'} 2xl:h-[50px]'} w-[100%] 2xl:py-[11px] 2xl:text-[14px] 2xl:leading-[28px] rounded h-[2.2rem] px-5 py-6 md:p-2 w-full outline-none lg:text-[14px] xl:text-[13px] xl:h-[35px] bg-[#F9F9F9] border border-gray-200 `} type="text" name="companyName" id="companyName" placeholder='Eg: XYZ Consultants' />
                          <p className='text-red-500 text-xs mt-1'>{errors.companyName && errors.companyName.message}</p>

                        </div>
                      </div>

                      {/* Job Title */}
                      <div className="field w-full mt-5 lg:mt-2 xl:mt-3 2xl:mt-4">
                        <div className="label">
                          <label htmlFor="companyName" className='text-black font--monstserrat font-medium md:font-normal md:text-[#5A5A5A] 2xl:text-[14px] 2xl:font-[600] 2xl:leading-[24px] lg:text-[14px]'>Job Title *</label>
                        </div>
                        <div className="input mt-2 xl:mt-0">
                          <input
                            {...register("jobTitle", {
                              required: {
                                value: true, message: "Field cannot be empty"
                              },
                              validate: { validateName }
                            })}
                            className={` ${errors.jobTitle && 'border border-red-500'} 2xl:h-[50px]'} w-[100%] 2xl:py-[11px] 2xl:text-[14px] 2xl:leading-[28px] rounded h-[2.2rem] px-5 py-6 md:p-2 outline-none lg:text-[14px] xl:text-[13px] xl:h-[35px] bg-[#F9F9F9] border border-gray-200 `} type="text" name="jobTitle" id="jobTitle" placeholder='Eg: HR Manager' />
                          <p className='text-red-500 text-xs mt-1'>{errors.jobTitle &&  errors.jobTitle.message}</p>

                        </div>
                      </div>

                      {/* Country */}
                      <div className="field w-full mt-5 lg:mt-2 xl:mt-3 2xl:mt-4">
                        <div className="label">
                          <label htmlFor="country" className='text-black font--monstserrat font-medium md:font-normal md:text-[#5A5A5A] 2xl:text-[14px] 2xl:font-[600] 2xl:leading-[24px] lg:text-[14px]'>Country *</label>
                        </div>
                        <div className="input mt-2 xl:mt-0">
                          <select  {...register("country", { required: true })} className={` ${errors.country && 'border border-red-500'} 2xl:h-[50px]'} w-[100%]  2xl:text-[14px] 2xl:leading-[28px] rounded h-[3.2rem] px-5 lg:py-2 md:p-2 outline-none lg:text-[14px] xl:text-[13px] 2xl:py-2 xl:h-[35px] bg-[#F9F9F9] border border-gray-200 `} type="text" name="country" id="country">
                            <option value="">Select Country</option>
                            {
                              countriesList.map((country, index) =>
                                <option value={country.label}>{country.label}</option>
                              )
                            }

                          </select>

                          <p className='text-red-500 text-xs mt-1'>{errors.country && 'Field cannot be empty'}</p>

                        </div>
                      </div>


                      <div className="field w-full mt-5 lg:mt-3">


                        <div className="checkBox flex items-center mt-5 lg:mt-2 text-[#ffd700]">
                          <input value="yes" {...register("isAgree", { required: true })} className='h-4 w-4 mr-2 flex-shrink-0' type="checkbox" />
                          <p className='xl:text-[13px] font--monstserrat 2xl:text-[12px] text-[#5A5A5A]'>I agree to the <span className='font-semibold underline'>
                            <a className='text-[#007E8C] font--monstserrat' href="https://thetalentgames.com/terms-of-use/">Terms of use</a></span> & <span className='font-semibold underline'>
                              <a className='text-[#007E8C] font--monstserrat' href="https://thetalentgames.com/privacy-policy/">Privacy Policy</a></span></p>
                        </div>
                        <p className='text-red-500 text-xs mt-1'>{errors.isAgree && 'To proceed, you must click the agreement check box above'}</p>

                        <div style={{
                          position: 'absolute',
                          bottom: '40px',
                          width: '340px',
                          margin: '0 auto',
                          lineHeight: 0,
                          left: 0,
                          right: 0
                        }}
                          className="proceed mt-5">
                          <button disabled={isSubmitted} type='submit' className='bg-[#007E8C] font--monstserrat h-[2.8rem] p-3 md:h-[2.5rem] md:p-2 w-full mt-5 rounded text-md text-[#ffffff]  xl:text-sm xl:mt-2 2xl:h-[2.5rem]'

                          >
                            <div className="  flex items-center justify-center">
                              {

                                isOTPTriggered &&
                                <div className="icon"> <i className="fa fa-circle-o-notch fa-spin mr-2 font--monstserrat" style={{ fontSize: "16px" }}></i></div>
                              }
                              <div className="text font-bold md:font-semibold">
                                {
                                  isSubmitted ? 'PLEASE WAIT' : 'Send One-Time-Password'
                                }
                              </div>
                            </div>

                          </button>

                          <button onClick={() => navigate('/')} className='bg-[#ffd700] font--monstserrat font-semibold h-[2.8rem] p-3 md:h-[2.5rem] md:p-2 w-full mt-5 rounded text-md text-[#4F4F4F]  xl:text-sm xl:mt-2 2xl:h-[2.5rem]' >
                            Cancel
                          </button>
                        </div>

                        <div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>

                {/* right side */}
                <div className="left lg:w-[50%] lg:flex lg:justify-between lg:items-start p-10 lg:p-0">

                  <div className="leftMainContent mx-auto mt-[1rem] flex flex-col items-center lg:items-start 2xl:items-start">
                    <h4 className='font--monstserrat text-[32px] text-[#007e8c] font-[800] 2xl:text-[28px]'>Your Plan Comes With</h4>
                    <div className="bulleticks mt-5 text-md">
                      {
                        planComesWith[tier].map((desc, index) =>
                          <div key={desc + index} className="bulletTick flex items-center mt-2">
                            <BsCheckCircleFill className='text-[#ffd700] bg-[#007e8c]  border-[#ffd700]  rounded-full 2xl:text-[26px] 2xl:mr-2' />
                            <p className='ml-2 font--monstserrat 2xl:text-[16px]'>{desc}</p>
                          </div>
                        )
                      }
                    </div>
                  </div>
                </div>



              </div>
            </div>
          </>
          :
          <div className="right-otp  lg:w-[100%]   bg-[white] my-2 mx-6">
            {isOtpSend ?
              <>
                <div className='heading relative'>
                  <h2 className='text-[1.5rem] font--monstserrat md:text-[1.8rem] pt-[40px] text-center font-bold  mt-2 text-[#007e8c] lg:text-[24px] 2xl:text-[32px] lg:mt-0 xl:text-[18px]'>
                    CONGRATULATIONS
                  </h2>
                  <div className='celebration-img absolute top-[16px] w-[82%] left-[59px] '>
                    <img src={toAbsoluteUrl('/media/signup/calebration-img.png')} />
                  </div>
                </div>

                <div className="form lg:w-[90%] max-w-[36rem] sm:w-[40rem] mx-auto lg:flex lg:flex-col lg:items-center lg:justify-center  lg:py-1 lg:mt-2 ">
                  <p className='text-[#434141] font--monstserrat text-center mt-[18px] mb-[16px] md:text-[16px] md:leading-[28px] lg:text-[16px] lg:leading-[28px] xl:text-[16px] xl:leading-[30px] 2xl:text-[18px] 2xl:leading-[32px] font-[500]'>
                    Your <b>FREE TRIAL</b> is ready! We have sent you an email with your log in details at <b>{email}</b>
                  </p>
                </div>

                <div className='btn-proceed text-center'>
                  <button onClick={handleSucceed} className='px-6 font--monstserrat mb-6 py-2 bg-[#007E8C] w-[250px] rounded leading-normal text-center'>
                    <span className="w-100 no-underline	 d-block text-white font--monstserrat text-lg capitalize ">click here to login</span>
                  </button>
                </div>

              </>
              :
              <div className="rightMainContent rounded-lg  w-[100%]">
                <div className="form lg:w-[100%] 2xl:w-[36rem] sm:w-[40rem] mx-auto lg:flex lg:flex-col lg:items-center lg:justify-center p-5 lg:py-1 px-8 lg:mt-2 ">
                  <div className="logo flex justify-center mb-10 xl:mb-3 lg:mb-5">
                    {/* ttg logo */}
                    {/* <img src={logoYellow} alt="logo" className='h-[3.5rem] object-contain md:h-[6rem] lg:h-[6rem] xl:h-[4rem] 2xl:h-[10rem]' /> */}
                  </div>

                  <h2 className='text-[1.5rem] md:text-[1.8rem] text-center font-semibold  uppercase   lg:text-[24px] 2xl:text-[32px] font--monstserrat lg:mt-3 xl:text-[18px]'>Please Enter The <span className='text-[#007e8c] font-bold'>OTP</span></h2>

                  {/* otp box */}
                  <div className="otpBox mt-[2rem] md:mt-[25px] flex flex-col justify-center items-center">
                    {/* otp avatar */}
                    <img src={toAbsoluteUrl('/media/signup/otpImage.png')} alt="otp avatar" className='block object-contain w-[40%] md:w-[50%]' />

                    <p className='text-[#434141] text-center mt-[22px] mb-[22px] md:text-[16px] md:leading-[28px] lg:text-[16px] lg:leading-[28px] xl:text-[16px] xl:leading-[30px] font--monstserrat 2xl:text-[20px] 2xl:leading-[24px] font-[500]'>Your OTP (one-time-password) has been generated and sent to your email address.</p>

                    <InputOTP value={otpValue} onChange={handleOTPChange} disabled={disabledOTPInput} numberOnly={true} error={otpError.error} errorMessage={otpError.errorMessage} autoFocus={true} />


                    {/* loader */}
                    {
                      <button onClick={handleOtpSubmit} className='px-6 mt-7 mb-8 py-3 bg-[#007E8C] w-[250px] rounded leading-normal text-center'>
                        <span className="w-100 no-underline	font--monstserrat d-block text-white font-medium text-lg capitalize ">Submit OTP</span>

                      </button>
                    }

                    {
                      disabledOTPInput && isEmailExists.isExists === true &&
                      <div className="loader">
                        <p>Please wait ..</p>
                      </div>
                    }
                    {
                      isEmailExists.isExists == false &&
                      <div className="loader">
                        <p>{isEmailExists.msg}</p>
                      </div>
                    }

                  </div>
                </div>
              </div>
            }


          </div>

      }
    </div>

  )
}

export default Signup

